"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _shape = _interopRequireDefault(require("../shape"));
const styleOverrides = {
  rounded: {
    borderRadius: _shape.default.largeComponentRadius
  },
  outlined: {
    border: `1px solid ${_constants.colors.oriGrey[500]}`
  }
};
var _default = exports.default = {
  styleOverrides
};
